// extracted by mini-css-extract-plugin
export default {"verify":"VerifyPass_verify__bT+xB","verifyform":"VerifyPass_verifyform__I0Bs6","button_common":"VerifyPass_button_common__kV1D9"};